import styled from 'styled-components'

const FlexedDiv = styled.div`
    display: flex;
    flex-direction: ${props => props.isVertical ? 'column' : 'row'};
    align-items: flex-start;
    margin: ${props => props.vMargin ? `${props.vMargin} 0` : ''};
    justify-content: space-between;
`

export default FlexedDiv
